import React from 'react';
import { ITestingElement } from '@insurancemenu/imenu-components-lib/dist/types';
import { SELECT_WITH_TAGS_ROLES } from '../constants';
import { TaggedSelectOptionType } from '../types';
import { OptionLabelStyled, OptionStyled, OptionTagStyled } from './styles';

export interface TaggedSelectOptionProps extends ITestingElement {
  option: TaggedSelectOptionType;
  isSelected: boolean;
  isFocused: boolean;
  optionRef: (element: HTMLLIElement | null) => void;
  onSelect: () => void;
  onKeyDown: (event: React.KeyboardEvent<HTMLLIElement>) => void;
}

const TaggedSelectOption: React.FC<TaggedSelectOptionProps> = ({
  option,
  isSelected,
  isFocused,
  optionRef,
  onSelect,
  onKeyDown,
  'data-test-id': dataTestId,
}) => {
  const isOptionDisabled = Boolean(option.disabled);

  const handleSelect = (): void => {
    if (isOptionDisabled) return;
    onSelect();
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLLIElement>): void => {
    if (isOptionDisabled) return;
    onKeyDown(event);
  };

  return (
    <OptionStyled
      role="option"
      aria-selected={isSelected}
      aria-disabled={isOptionDisabled}
      tabIndex={!isOptionDisabled && isFocused ? 0 : -1}
      ref={optionRef}
      data-role={SELECT_WITH_TAGS_ROLES.OPTION}
      data-test-for={dataTestId}
      onClick={handleSelect}
      onKeyDown={handleKeyDown}
      $isDisabled={isOptionDisabled}
      $isSelected={isSelected}
    >
      <OptionLabelStyled
        $isDisabled={isOptionDisabled}
        data-role={SELECT_WITH_TAGS_ROLES.OPTION_LABEL}
        data-test-for={dataTestId}
      >
        {option.label}
      </OptionLabelStyled>
      {option.tag && (
        <OptionTagStyled data-role={SELECT_WITH_TAGS_ROLES.OPTION_TAG} data-test-for={dataTestId}>
          {option.tag}
        </OptionTagStyled>
      )}
    </OptionStyled>
  );
};

export default TaggedSelectOption;
